import { LoanDetailsModel } from "./model";

export const LoanDetailsSerializer = () => {
  const loanDetailsModel = LoanDetailsModel();

  const updateOverview = async (body) =>
    await loanDetailsModel.updateOverview(body);
  const updateBorrower = async (body) =>
    await loanDetailsModel.updateBorrower(body);
  const updateAdditionalGuarantors = async (body) =>
    await loanDetailsModel.updateGuarantor(body);

  return Object.freeze({
    updateOverview,
    updateBorrower,
    updateAdditionalGuarantors,
  });
};
